import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './Layout';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import './styles/components.css';
import './styles/global.css';

// Lazy-load páginas secundarias para mejor performance
const ProjectsPage  = lazy(() => import('./pages/ProjectsPage'));
const Tegnologias   = lazy(() => import('./pages/Tegnologias'));
const ServicesPage  = lazy(() => import('./pages/ServicesPage'));

const PageLoader = () => (
  <div className="global-loading" style={{ height: '60vh' }}>Cargando...</div>
);

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* Home: todas las secciones en una sola página */}
        <Route
          index
          element={
            <>
              <Hero />
              <About />
              <Services />
              <FAQ />
              <Contact />
            </>
          }
        />

        {/* Páginas secundarias — lazy loaded */}
        <Route
          path="projects"
          element={
            <Suspense fallback={<PageLoader />}>
              <ProjectsPage />
            </Suspense>
          }
        />
        <Route
          path="servicios"
          element={
            <Suspense fallback={<PageLoader />}>
              <ServicesPage />
            </Suspense>
          }
        />
        <Route
          path="tegnologias"
          element={
            <Suspense fallback={<PageLoader />}>
              <Tegnologias />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
}

export default App;
